import state from './orderState'
import mutations from './orderMutations'
import getters from './orderGetters'
import actions from './orderActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
